<template>
  <!-- Alternativa con teclado al drag & drop: subir / bajar un elemento -->
  <div class="flex flex-col flex-shrink-0">
    <button type="button" :disabled="disabled || !canMoveUp" :title="upLabel" :aria-label="upLabel" v-on:click="$emit('move-up')"
            class="p-1.5 md:p-0.5 rounded-md text-gray-500 hover:text-gray-700 disabled:opacity-30 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-bpblue">
      <font-awesome-icon icon="chevron-up" class="h-4 w-4" aria-hidden="true"/>
    </button>
    <button type="button" :disabled="disabled || !canMoveDown" :title="downLabel" :aria-label="downLabel" v-on:click="$emit('move-down')"
            class="p-1.5 md:p-0.5 rounded-md text-gray-500 hover:text-gray-700 disabled:opacity-30 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-bpblue">
      <font-awesome-icon icon="chevron-down" class="h-4 w-4" aria-hidden="true"/>
    </button>
  </div>
</template>

<script>
export default {
  name: "ReorderButtonsComponent",
  props: {
    canMoveUp: {
      type: Boolean,
      default: true
    },
    canMoveDown: {
      type: Boolean,
      default: true
    },
    upLabel: {
      type: String,
      required: true
    },
    downLabel: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['move-up', 'move-down'],
}
</script>
